import Vue from 'vue';
import VueI18n from 'vue-i18n';

import messages from './assets/locales/messages.json';

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: 'default', // set locale
  fallbackLocale: 'default',
  messages,
});

i18n.setLocaleMessage('default', messages);

export default i18n;
